import React from 'react';
import { string } from 'prop-types';
import { Box, Center, Text, Heading, Button } from '@chakra-ui/react';

import useLang from '@/hooks/useLang';
import useInvitation from '@/hooks/useInvitation';

import CountDown from '@/components/Common/CountDown';
import AddToCalendar from '@/components/Common/AddToCalendar';
import WithAnimation from '@/components/Common/WithAnimation';

import { BUTTON_PADDING_PROPS } from '@/constants/colors';
import { WEDDING_RESEPSI_FULLDATE } from '@/constants/';
import { ENABLE_MUSLIM_LANGUAGE } from '@/constants/feature-flags';
import { TEXT_PROPS } from '@/constants/default-props';

import { styleCountdown } from './styles';
import txt from './locales';
import generateShift from '@/hooks/useShift';
import { useGuest } from '@/context/guest';

function CountingDown() {
  const isInvitation = useInvitation();
  const lang = useLang();

  const { guest } = useGuest();
  const shiftTime = generateShift(guest.shift);

  return (
    <Box
      minHeight={{ '3sm': '60vh', '2sm': '60vh', '1sm': '70vh', base: '80vh' }}
      paddingTop="32px"
      className={styleCountdown}
      paddingBottom={shiftTime != 'resepsi' ? '32px' : '' }
    >
      {/* COUNTING SECTION */}
      <Box marginTop={{ lg: '9vmax', base: '24px' }} position="relative">
        <Box pos="relative" zIndex="2">
          <WithAnimation>
            {ENABLE_MUSLIM_LANGUAGE ? (
              <Text {...TEXT_PROPS.body} textAlign="center">
                {isInvitation ? (
                  <span dangerouslySetInnerHTML={{ __html: txt.openingMuslimInvitation[lang] }} />
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: txt.openingMuslimAnnouncement[lang] }} />
                )}
              </Text>
            ) : (
              <Text {...TEXT_PROPS.body} textAlign="center">
                {isInvitation ? (
                  <span dangerouslySetInnerHTML={{ __html: txt.openingGeneralInvitation[lang] }} />
                ) : (
                  <span
                    dangerouslySetInnerHTML={{ __html: txt.openingGeneralAnnouncement[lang] }}
                  />
                )}
              </Text>
            )}
            <Box
              width="50px"
              height="3px"
              margin="40px auto"
              background="bgSecondary"
              borderRadius="8px"
              transform="rotate(-90deg)"
            />
          </WithAnimation>
          <WithAnimation>
            <Heading
              {...TEXT_PROPS.heading}
              pos="relative"
              zIndex="2"
              textTransform="none"
              paddingTop="20px"
              textAlign="center"
              fontSize="42px"
              letterSpacing="-1px"
            >
              Save the Date!
            </Heading>
            <Text
              {...TEXT_PROPS.body}
              fontWeight="500"
              fontSize="18px"
              textAlign="center"
              paddingBottom="0"
            >
              {WEDDING_RESEPSI_FULLDATE[lang]}
            </Text>
          </WithAnimation>
        </Box>
        {/* Countdown */}
        <Center flexDir="column" pos="relative" zIndex="2">
          <WithAnimation>
            <CountDown lang={lang} pos="relative" zIndex="2" />
          </WithAnimation>
        </Center>
        {/* Add to Calendar Button */}
        {isInvitation && (
          <>
            <Center flexDir="column" pos="relative" zIndex="2">
              <WithAnimation>
                <Button
                  {...BUTTON_PADDING_PROPS}
                  fontWeight="normal"
                  marginTop="16px"
                  position="relative"
                >
                  {txt.reminder[lang]}
                </Button>
              </WithAnimation>
            </Center>
            <Center flexDir="column" pos="relative" zIndex="3" mt="-52px">
              <AddToCalendar
                text={txt.reminder[lang]}
                {...BUTTON_PADDING_PROPS}
                fontWeight="normal"
                m="16px 0 24px"
                position="relative"
                zIndex="99"
                opacity="0"
                _hover={{
                  bg: 'whiteAlpha.200',
                  opacity: '1',
                }}
              />
            </Center>
          </>
        )}
      </Box>
    </Box>
  );
}

CountingDown.propTypes = {
  lang: string.isRequired,
};

export default CountingDown;
